import { render, staticRenderFns } from "./CustomerGroupNew.vue?vue&type=template&id=2ee67cdb&"
import script from "./CustomerGroupNew.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports